import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

const Loader = styled.div`
  border: 16px solid ${(p) => p.theme.light};
  border-top: 16px solid ${(p) => p.theme.primary};
  border-radius: 50%;
  width: 120px;
  height: 120px;
  animation: ${spin} 2s linear infinite;
`;

const Div = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${(p) => p.theme.background};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Text = styled.h2`
  font-size: 1.2rem;
  padding-top: 2rem;
  font-weight: 400;
`;

function Loading() {
  return (
    <Div>
      <Loader />
      <Text>Cargando...</Text>
    </Div>
  );
}

export default Loading;
